import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

class PublicRoute extends Component {
  render() {
    const { component: Component } = this.props;
    const isAuthenticated = localStorage.getItem('user_token'); // Check if token exists
    return isAuthenticated ? <Navigate to="/" /> : <Component />;
  }
}

export default PublicRoute;
